module.exports = new __parcel__URL__("logo_sellor.d402d7de.svg").toString();